export default "__VITE_ASSET__4ea8a918__"